import { PropType, computed, defineComponent, ref } from 'vue'

import { CsDropdown, CsPrimaryButton, MsHeadline } from '@sunrise/components'
import { MsLoupe } from '@sunrise/icons'
import { screenSizeDetection } from '@sunrise/shared'

import { SearchFilters } from '../../ts/service/realEstateService.interface'
import { useResultListStore } from '../../ts/store/resultListStoreModule/resultListStoreModule'

import MsHouse from '../../static/illus/real-estate-house-brand-searchbox.svg?component'
import { FlexDirection } from '../MsFilterPropertyType/MsFilterPropertyType.enum'
import MsFilterPropertyType from '../MsFilterPropertyType/MsFilterPropertyType.vue'
import MsCircle from './icons/real-estate-circle-brand-searchbox.svg?component'

export default defineComponent({
    name: 'MsSearchBox',
    components: {
        MsFilterPropertyType,
        CsDropdown,
        CsPrimaryButton,
        MsCircle,
        MsHouse,
        MsLoupe,
        MsHeadline,
    },
    props: {
        isLoading: { type: Boolean, default: false },
        searchFilters: { type: Object as PropType<SearchFilters>, required: true },
        totalCount: { type: Number, required: true },
    },
    emits: ['openFilterModal', 'scrollToTop'],
    setup(props, { emit }) {
        const headline = computed(() => useResultListStore().searchBoxHeadline)
        const { isScreenM, isScreenL } = screenSizeDetection()
        const elSearchbox = ref<HTMLDivElement | null>(null)

        function createResultButtonText(): string {
            if (props.totalCount === 0) {
                return '0 Ergebnisse'
            } else if (props.totalCount === 1) {
                return '1 Ergebnis'
            } else {
                return `${props.totalCount.toLocaleString('de-DE')} Ergebnisse`
            }
        }

        function scrollToTop(): void {
            emit('scrollToTop')
        }

        function openFilterModal() {
            emit('openFilterModal')
        }

        return {
            FlexDirection,
            headline,
            isScreenM,
            isScreenL,
            elSearchbox,
            createResultButtonText,
            scrollToTop,
            openFilterModal,
        }
    },
})
